import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";

import {
  Space,
  Button,
  Drawer,
  Form,
  Input,
  Alert
} from '@lockerpm/design';

import global from '../../../../config/global';
import relayServices from '../../../../services/relay';

function SubdomainForm(props) {
  const {
    visible = false,
    subdomains = [],
    onClose = () => {},
  } = props
  const { t } = useTranslation()
  const [callingAPI, setCallingAPI] = useState(false);
  const [subdomain, setSubdomain] = useState('');

  const [form] = Form.useForm();
  const newDomain = Form.useWatch('new_subdomain', form)

  useEffect(() => {
    setSubdomain(subdomains[0]);
    form.setFieldValue('new_subdomain', subdomains[0]?.subdomain)
  }, [visible, subdomains])

  const handleSave = () => {
    form.validateFields().then(() => {
      if (subdomain?.id) {
        updateSubdomain();
      } else {
        createSubdomain();
      }
    })
  }

  const createSubdomain = async () => {
    setCallingAPI(true);
    await relayServices.create_subdomain({ subdomain: newDomain }).then(() => {
      global.pushSuccess(t('notification.success.subdomain.created'));
      onClose(true)
    }).catch((error) => {
      global.pushError(error)
    })
    setCallingAPI(false);
  }

  const updateSubdomain = async () => {
    setCallingAPI(true);
    await relayServices.update_subdomain(subdomain.id, { subdomain: newDomain }).then(() => {
      global.pushSuccess(t('notification.success.subdomain.updated'));
      onClose(true)
    }).catch((error) => {
      global.pushError(error)
    })
    setCallingAPI(false);
  }

  return (
    <div className={props.className}>
      <Drawer
        title={subdomain ? t( `private_email.manage_subdomain.change_subdomain`) : t( `private_email.manage_subdomain.create_subdomain`)}
        placement="right"
        onClose={onClose}
        open={visible}
        width={500}
        footer={
          <Space className='flex items-center justify-end'>
            <Button
              disabled={callingAPI}
              onClick={onClose}
            >
              {t('button.cancel')}
            </Button>
            <Button
              type="primary"
              disabled={!newDomain || subdomain?.subdomain === newDomain}
              loading={callingAPI}
              onClick={() => handleSave()}
            >
            { t('button.save') } 
            </Button>
          </Space>
        }
      >
        {
          subdomain && <p className='font-semibold mb-4'>
            {t('private_email.manage_subdomain.your_subdomain')}: <span className='text-primary'>@{subdomain.subdomain}{global.constants.SUB_DOMAIN}</span>
          </p>
        }
        <Form
          form={form}
          layout="vertical"
          labelAlign={'left'}
        >
          <Form.Item
            name={'new_subdomain'}
            label={<p>{t('private_email.manage_subdomain.new_subdomain')}</p>}
            rules={[
              global.rules.LIMIT_LENGTH(3, 63, t('private_email.manage_subdomain.subdomain.limit')),
              global.rules.INVALID('', 'ALIAS', t('private_email.manage_subdomain.subdomain.invalid'))
            ]}
          >
            <Input
              addonBefore="@"
              addonAfter={global.constants.SUB_DOMAIN}
              disabled={callingAPI}
              placeholder={t('placeholder.enter')}
              showCount
              minLength={6}
              maxLength={63}
            />
          </Form.Item>
        </Form>
        {
          !subdomain && <div>
            <p className='mb-2'><i>{t('common.example')}: viktor@viktor-agency.maily.org</i></p>
            <p>{t('private_email.manage_subdomain.create_desc')}</p>
          </div>
        }
        {
          subdomain && <Alert
            className='p-4'
            message={<p className='font-semibold'>{t('common.warning')}</p>}
            description={t('private_email.manage_subdomain.update_desc')}
            type="warning"
            closable={false}
          />
        }
      </Drawer>
    </div>
  );
}

export default SubdomainForm;
